module.exports = __webpack_public_path__ + "img/polotitlan.cfd1dd04.jpg";